import { render, staticRenderFns } from "./VeDividerBlockSettings.vue?vue&type=template&id=c29d4a0c"
import script from "./VeDividerBlockSettings.vue?vue&type=script&lang=js"
export * from "./VeDividerBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports